
<P class="air-heading">	Lead Engineering Details</P>
<div *ngIf="!savedLE">
<div class="grid" >
  <!-- Left column content -->
  <div class="col-6 flex flex-column">
    <!-- Operations section -->

    <p-table
      [value]="operationsData"
      
      styleClass="p-datatable-gridlines"
      id="StyleTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Operations</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.key }}</td>
          <td [class]="item.class">{{ item.value }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer"> </ng-template>
    </p-table>

    <p-table
      [value]="InspectionData"
      
      styleClass="p-datatable-gridlines"
      id="StyleTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Inspections</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer"> </ng-template>
    </p-table>

    <div></div>
  </div>
  <!-- Right COLUMN CONTEXT -->
  <div class="col-6 flex flex-column">
    <p-table
      [value]="MaximoData"
      
      styleClass="p-datatable-gridlines"
      id="StyleTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Maximos</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer"> </ng-template>
    </p-table>

    <p-table
      [value]="EngineeringData"
      styleClass="p-datatable-gridlines"
      id="StyleTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Engineering</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer"> </ng-template>
    </p-table>

    <div></div>
  </div>
</div>
<div >
  <table class="custom-table" style="padding : 1 rem">
    <thead>
      <tr>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="isLEUpdate">
        <td style="width: 50%" class="textTitle">
          Currently Assigned to Engineer's User ID: <span style="font-weight :normal ;" class="ml-10">{{ assignedCAI }}</span>
        </td>
        <td style="width: 50%" class="textTitle" style="font-weight :normal ;">({{ assignedEmail }} )</td>
      </tr>
      <tr>
        <td>
          <div>
            <p class="textTitle">Assign To Engineer's User ID:</p>
            <div style="display: flex;align-items: flex-start;">
            <input
              type="text"
              placeholder="Email ID"
              style="width: 250px"
              (keydown.enter)="validateUser()"
              [(ngModel)]="userId"
            />
            <button
              pButton
              class="btn-primary ml-10 ht-25"
              (click)="validateUser()"
            >
              Verify User
            </button>
            <p class="red ml-10">* enter email id</p>
        </div>
          </div>
        </td>
        <td>
          <div *ngIf="isUserValid">
            <p class="textTable">Email : {{ userEmail }}</p>
            <p class="textTable">Full Name: {{ userFullName }}</p>
            <p class="textTable">City : {{ userCity }}</p>
            <p class="textTable">Phone : {{ userPhone }}</p>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <p class="textTitle">Lead Engineer Email Message:</p>
            <input
              type="text"
              placeholder="Engineer Message"
              style="width: 700px"
              [(ngModel)]="leadengineerComment"
            />
          </div>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>
            <div class="d-flex ht-25 justify-center">
              <button pButton class="ht-25 cancel-btn" (click)="saveLE()">
                save
              </button>
          </div>
        </td>
        <td>

        </td>
      </tr>
    </tbody>
  </table>
</div>
</div>
<div *ngIf="savedLE">
  <p class="SuccessMessage">Engineering User Id is Assigned</p>
</div>
